const { LOGIN, LOGIN_ERROR, LOGOUT } = require('../Constants/login.constants');

const initalState = {
    loggedInUser: {},
    error: {
        code: '',
        message: ''
    }
};

export default (state = initalState, action) => {
    switch (action.type) {
        case LOGIN:
            return {
                error: {
                    code: '',
                    message: ''
                },
                loggedInUser: action.data
            };
        case LOGOUT: {
            return {
                ...initalState
            };
        }
        case LOGIN_ERROR: {
            return {
                ...state,
                error: {
                    message: action.data
                }
            };
        }
        default:
            return state;
    }
};
